<template>
  <b-modal id="log-extra-statuses-modal" size="lg" title="Extra Status Logs" >
    
    <b-table  striped hover :items="logs">
      <!-- A custom formatted column -->
      <template #cell(action_type)="data">
        <b-badge :variant="data.value == 'add' ? 'success' : data.value == 'remove' ? 'danger' : 'dark'">{{ data.value.toUpperCase() }}</b-badge>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import EventBus from '../../../EventBus'
import moment from 'moment';

  export default {
    data(){
      return {
        logs: []
      }
    },
    mounted(){
      EventBus.$on('log-extra-statuses', logs => {
        this.logs = logs.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.createdAt) - new Date(a.createdAt);
          }).map((log, index) => {
          return {
            index: index + 1,
            doer: log.doer.username,
            extra_status: log.ExtraStatus.name,
            date_time: moment(log.createdAt).utc().format("dddd, MMMM Do YYYY, h:mm:ss a"),
            action_taken_from: log.actionTakenFrom ? log.actionTakenFrom : "Unknown",
            action_type: log.actionType,
          }
        })
      })
    },
    beforeDestroy(){
      EventBus.$off('log-extra-statuses')
    }
  }
</script>

<style lang="scss" scoped>

</style>